import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { NonNullDynamicState } from '@us/web/shared/data-access';
import { Preference } from '../models';
import { PreferenceActions } from './preference.actions';

export const PREFERENCE_FEATURE_KEY = 'preference';

export type State = NonNullDynamicState<'preference', Preference>;

export const initialState: State = {
    preference: {
        language: null
    },
    status: 'pending',
    error: null
};

export const patchPreference = (state: State, preference: Partial<Preference>): State => ({
    ...state,
    preference: { ...state.preference, ...preference }
});

export const preferenceFeature = createFeature({
    name: PREFERENCE_FEATURE_KEY,
    reducer: createReducer(initialState, on(PreferenceActions.patchPreference, patchPreference))
});

export const { selectPreferenceState, selectPreference } = preferenceFeature;

export const selectLanguage = createSelector(selectPreference, preference => preference.language);
